import http from './http.service';

class PublicBookingService {
    constructor() {
        if (PublicBookingService.instance) {
            return PublicBookingService.instance;
        }

        PublicBookingService.instance = this;
    }

    search(queryObj) {
        return http.get('/public-booking/search', { params: queryObj }).then(res => res.data);
    }
    getVehicle(queryObj) {
        return http.get('/public-booking/vehicle', { params: queryObj }).then(res => res.data);
    }
    checkPromocode(queryObj) {
        return http.get('/public-booking/check-promocode', { params: queryObj }).then(res => res.data);
    }
    store(data) {
        return http.post('/public-booking/store', data).then(res => res.data);
    }
    checkIsVehicleBooked(queryObj) {
        return http.get('/public-booking/check-is-vehicle-booked', { params: queryObj }).then(res => res.data);
    }
    checkClientDiscount(queryObj) {
        return http.get('/public-booking/check-client-discount', { params: queryObj }).then(res => res.data);
    }
    checkOffer(queryObj) {
        return http.get('/public-booking/check-offer', { params: queryObj }).then(res => res.data);
    }
    checkPaidServices(vehicleId, queryObj) {
        return http.get(`/public-booking/${vehicleId}/check-paid-services`, { params: queryObj }).then(res => res.data);
    }
}

export default new PublicBookingService();
